<script setup lang="ts">
import { computed } from 'vue';
import { usePromoComposable } from '../admin/usePromoComposable';
import { useViewComposable } from '@/views/composable';
import Button from 'primevue/button';
import MultiSelect from 'primevue/multiselect';

const props = defineProps<{
  title: string;
  jawType: string;
  brochureCode?: string[];
}>();

const emits = defineEmits<{
  handleUpdateConfig: [value: any];
  'update:brochureCode': [value: any];
}>();

const { brochureListOption } = useViewComposable();
const { canEditConfigurableItem } = usePromoComposable();

const brochure = computed({
  get() {
    return props.brochureCode;
  },
  set(value) {
    emits('update:brochureCode', value);
  }
});

const handleUpdateConfig = async (jawType: string) => {
  emits('handleUpdateConfig', {
    jawType: jawType,
    data: brochure.value
  });
};
</script>
<template>
  <div class="flex mb-3 input-number-field">
    <div class="col-2 align-self-center mr-3">
      <div>{{ title }}</div>
    </div>
    <MultiSelect :disabled="!canEditConfigurableItem" display="chip" :maxSelectedLabels="1" v-model="brochure" :options="brochureListOption" :placeholder="$t('management.package.select_brochure')" class="w-6 mr-3" />
    <Button v-if="canEditConfigurableItem" :label="$t('promos.save')" icon="pi pi-check save-btn" class="mr-2 bg-primary save-btn" @click="handleUpdateConfig(jawType)" />
  </div>
</template>
